export default __webpack_public_path__ + "static/media/luck.20b9861a.jpeg";